import { Redirect } from 'expo-router';

import { useAuthContext } from 'state/auth';
import { routes } from 'utils/routing';

// This hook is used to redirect the user to the base route if they are authenticated. When the user is
// in the modal auth state, we don't want to redirect them to the base route
export default function useUnauthRedirects() {
  const { loading, isAuthenticated, modalAuthIsOpen } = useAuthContext();

  if (!loading && !modalAuthIsOpen && isAuthenticated) {
    return <Redirect href={routes.base} />;
  }

  return null;
}
